__turbopack_context__.v({
  "control": "not-found-module__sajp7a__control",
  "desktopImage": "not-found-module__sajp7a__desktopImage",
  "mobileImage": "not-found-module__sajp7a__mobileImage",
  "root": "not-found-module__sajp7a__root",
  "title": "not-found-module__sajp7a__title",
});
